<template lang="pug">
div
  .text-center
    h2.font-sans.text-4xl.leading-none.mb-4(class="xl:text-7xl") Contactez le n°1 de l’immobilier du nord-est !
    p.mb-8.leading-none(class="xl:mb-12") Notre équipe d’experts est à votre service pour répondre à vos questions

  .max-w-3xl.mx-auto
    form(@submit.prevent="onSubmit")
      .form-group(v-if="Object.keys(errors).length")
        .alert.error_explanation
          form-error(:errors="errors")

      div
        .form-group
          input#contact_lastname.form-control(v-model="contact.lastname" type="text" required="required" placeholder="Nom" :class="{'field_with_errors': errors.lastname}")

        .form-group
          input#contact_firstname.form-control(v-model="contact.firstname" type="text" required="required" placeholder="Prénom" :class="{'field_with_errors': errors.firstname}")

        .form-group
          input#contact_email.form-control(v-model="contact.email" type="email" required="required" placeholder="E-mail *" :class="{'field_with_errors': errors.base}")

        .form-group
          input#contact_phone.form-control(v-model="contact.phone" type="phone" required="required" placeholder="Téléphone *" :class="{'field_with_errors': errors.base}")

        .mb-6
          .bg-white.inline-block.border-2.border-gray-400.relative.text-base.text-gray.font-normal.text-left.rounded.leading-10.w-full.overflow-hidden(v-if="subjects.length > 0")
            select.bg-transparent.appearance-none.w-full.px-8.py-select(v-model="contact.subject" required="required")
              option(v-for="(subject, index) in subjects" :key="index" :value="subject.value") {{ subject.label }}
            span.fal.fa-chevron-down.text-lg.text-primary.font-medium.absolute(class="top-1/2 right-4 transform -translate-y-1/2 pointer-events-none")

        .form-group
          input#contact_geographical_zone.form-control(v-model="contact.geographical_zone" type="text" placeholder="Zone géographique de votre projet" :class="{'field_with_errors': errors.base}")

        .mb-6
          textarea#contact_message.form-control(v-model="contact.message" rows="8" required="required" placeholder="Message" :class="{'field_with_errors': errors.message}")

        .mb-6
          label(class="checkbox-native inline-block font-sans relative pl-10 mr-12 text-xs font-light text-gray-800 cursor-pointer select-none")
            span En soumettant ce formulaire, j’accepte que les informations saisies dans ce formulaire soient utilisées, exploitées, traitées pour permettre de me recontacter. Découvrez comment nous recueillons, utilisons et partageons vos données en lisant notre Politique d’utilisation des données.
            input(class="checkbox-native__input absolute opacity-0 cursor-pointer h-0 w-0" type="checkbox" name="rgpd_terms_accepted" value="true" v-model="contact.rgpd_terms_accepted")
            span(class="checkbox-native__checkmark absolute top-2 left-0 w-6 h-6 border border-black rounded-sm")

        .mt-8.text-center(class="xl:mt-12 xl:mt-0 xl:ml-12 xl:text-left")
          vue-recaptcha(
            ref="recaptcha"
            size="invisible"
            :sitekey="recaptchaAppKey"
            @verify="onCaptchaVerify"
            @expired="onCaptchaExpired"
          )

        input(type="submit" :id="submitButtonId" :disabled="!canSubmit" value="Envoyer" class="btn btn-lg w-full btn-primary mb-8")

        p.text-gray-100.font-italic.text-center * Veuillez renseigner au moins l’un des deux champs.
  </template>

<script>
import ContactForm from '@components/ContactForm'

export default {
  extends: ContactForm
}
</script>
